import { createTheme } from '@mui/material'
import { PURPLE, SPRING_GREEN } from '@fixrate/pangea'

// Fixrate design tokens sourced from @fixrate/pangea — the shared token
// package marketplace uses — so a rebrand there propagates here. Montserrat
// everywhere, deep-purple ink, interactive purple, spring-green accent,
// near-square radius, flat surfaces. The few neutrals pangea doesn't expose
// (canvas grey, border) come from the design system's tokens.css.
const PURPLE_900 = PURPLE[900]
const PURPLE_500 = PURPLE[500]
const PURPLE_600 = PURPLE[600]
const SPRING_500 = SPRING_GREEN[500]
const BG_CANVAS = '#F2F2F2'
const BG_TINT = PURPLE[50]
const BORDER_DEFAULT = '#DFE1DF'
const TEXT_SECONDARY = '#6E7271'

const FONT = '"Montserrat", "Helvetica Neue", Arial, sans-serif'

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: PURPLE_500, dark: PURPLE_600 },
        secondary: { main: SPRING_500 },
        background: { default: BG_CANVAS },
        text: { primary: PURPLE_900, secondary: TEXT_SECONDARY },
        divider: BORDER_DEFAULT,
    },
    typography: {
        // Montserrat's base weight in Fixrate UI is 500, not 400.
        fontFamily: FONT,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 700,
        // The login + consent headings mirror the marketplace modal title
        // (~2rem) rather than a large page heading.
        h1: { fontSize: '2rem', fontWeight: 700, color: PURPLE_900 },
        h2: { fontSize: '1.6rem', fontWeight: 700, color: PURPLE_900 },
        button: { fontWeight: 600, textTransform: 'none' },
    },
    // 0.3rem ≈ 3px at the design system's 10px root; MUI uses px, and the
    // marketplace dialog itself renders at ~4px. Keep near-square.
    shape: { borderRadius: 4 },
    components: {
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                // Flat buttons — the Fixrate look has no shadow.
                root: { boxShadow: 'none', ':hover': { boxShadow: 'none' } },
            },
        },
        MuiPaper: {
            styleOverrides: {
                // Standard card shadow from the design tokens.
                outlined: { borderColor: BORDER_DEFAULT },
            },
        },
    },
})

export const tokens = {
    PURPLE_900,
    PURPLE_500,
    PURPLE_600,
    SPRING_500,
    BG_CANVAS,
    BG_TINT,
    BORDER_DEFAULT,
    TEXT_SECONDARY,
}
